import React from "react"
import types from "prop-types"
import { MenuButton } from "@szhsin/react-menu"
import { useSelector } from "react-redux"
import { currentUserIsPhpAdmin as getCurrentUserIsPhpAdmin } from "reduxSlices/sessionSlice"
import * as API from "services/api"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import { errorToast, successToast } from "components/shared/toast"

const ReportableFieldMenu = ({
  categorySlug, setReportableFields, reportableFields, reportableFieldId, setFormEditField,
}) => {
  const currentUserIsPhpAdmin = useSelector(getCurrentUserIsPhpAdmin)

  if (!currentUserIsPhpAdmin) return null

  const removeReportableField = async () => {
    if (window.confirm("Are you sure you want to delete this field?")) {
      const response = await API.deleteCategoryReportableField({ categorySlug, reportableFieldId })
      if (response.ok) {
        successToast("Reportable field successfully deleted.")
        setReportableFields(reportableFields.filter(({ id }) => id !== reportableFieldId))
      } else {
        errorToast("Something went wrong.  Unable to delete reportable field.")
      }
    }
  }

  return (
    <div>
      <ExpandMenu
        expandMenuComponent={(
          <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
            <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
          </MenuButton>
        )}
      >
        <ExpandMenuItem onClick={setFormEditField}>
          <span>Edit</span>
        </ExpandMenuItem>
        <ExpandMenuItem onClick={removeReportableField}>
          <span>Delete</span>
        </ExpandMenuItem>
      </ExpandMenu>
    </div>
  )
}

ReportableFieldMenu.propTypes = {
  categorySlug: types.string.isRequired,
  setReportableFields: types.func.isRequired,
  reportableFields: types.arrayOf(types.object).isRequired,
  reportableFieldId: types.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  setFormEditField: types.func.isRequired,
}

export default ReportableFieldMenu
